export class CategoriaUniformeModel {
  claveTipoUniforme: string;
  tipoUniforme: string;
  fuc: string;
  precio: string;

  constructor() {
  }
}